"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroXSwapRecipe = void 0;
const approve_erc20_spender_step_1 = require("../../steps/token/erc20/approve-erc20-spender-step");
const zero_x_quote_1 = require("../../api/zero-x/zero-x-quote");
const zero_x_swap_step_1 = require("../../steps/swap/zero-x/zero-x-swap-step");
const swap_recipe_1 = require("./swap-recipe");
const shared_models_1 = require("@railgun-community/shared-models");
const utils_1 = require("../../utils");
const min_gas_limits_1 = require("../../models/min-gas-limits");
const steps_1 = require("../../steps");
const designate_shield_erc20_recipient_step_1 = require("../../steps/railgun/designate-shield-erc20-recipient-step");
class ZeroXSwapRecipe extends swap_recipe_1.SwapRecipe {
    config = {
        name: '0x Exchange Swap',
        description: 'Swaps two ERC20 tokens using 0x Exchange DEX Aggregator.',
        minGasLimit: min_gas_limits_1.MIN_GAS_LIMIT_0X_SWAP,
    };
    sellERC20Info;
    buyERC20Info;
    slippageBasisPoints;
    destinationAddress;
    isRailgunDestinationAddress;
    constructor(sellERC20Info, buyERC20Info, slippageBasisPoints, destinationAddress) {
        super();
        this.sellERC20Info = sellERC20Info;
        this.buyERC20Info = buyERC20Info;
        this.slippageBasisPoints = slippageBasisPoints;
        this.destinationAddress = destinationAddress;
        if ((0, shared_models_1.isDefined)(destinationAddress)) {
            this.isRailgunDestinationAddress =
                (0, utils_1.getIsUnvalidatedRailgunAddress)(destinationAddress);
            if (this.isRailgunDestinationAddress) {
                this.config.name += ' and Shield';
                this.config.minGasLimit = min_gas_limits_1.MIN_GAS_LIMIT_0X_SWAP_SHIELD;
            }
            else {
                this.config.name += ' and Transfer';
                this.config.minGasLimit = min_gas_limits_1.MIN_GAS_LIMIT_0X_SWAP_TRANSFER;
            }
        }
    }
    supportsNetwork(networkName) {
        return zero_x_quote_1.ZeroXQuote.supportsNetwork(networkName);
    }
    async getSwapQuote(networkName, sellERC20Amount) {
        const quoteParams = {
            networkName,
            sellERC20Amount,
            buyERC20Info: this.buyERC20Info,
            slippageBasisPoints: this.slippageBasisPoints,
            isRailgun: true,
        };
        return zero_x_quote_1.ZeroXQuote.getSwapQuote(quoteParams);
    }
    async getInternalSteps(firstInternalStepInput) {
        const { networkName } = firstInternalStepInput;
        const sellERC20Amount = (0, utils_1.findFirstInputERC20Amount)(firstInternalStepInput.erc20Amounts, this.sellERC20Info);
        this.quote = await this.getSwapQuote(networkName, sellERC20Amount);
        const steps = [
            new approve_erc20_spender_step_1.ApproveERC20SpenderStep(this.quote.spender, sellERC20Amount),
            new zero_x_swap_step_1.ZeroXSwapStep(this.quote, this.sellERC20Info),
        ];
        if ((0, shared_models_1.isDefined)(this.destinationAddress)) {
            steps.push(this.isRailgunDestinationAddress === true
                ? new designate_shield_erc20_recipient_step_1.DesignateShieldERC20RecipientStep(this.destinationAddress, [
                    this.buyERC20Info,
                ])
                : this.buyERC20Info.isBaseToken ?? false
                    ? new steps_1.TransferBaseTokenStep(this.destinationAddress)
                    : new steps_1.TransferERC20Step(this.destinationAddress, this.buyERC20Info));
        }
        return steps;
    }
}
exports.ZeroXSwapRecipe = ZeroXSwapRecipe;
